const badgeVariants = {
  light_primary: "light-primary",
  light_secondary: "light-secondary",
  light_dark: "light-dark",
  light_tertiary: "light-tertiary",
  primary: "primary",
  secondary: "secondary",
  dark: "dark",
  tertiary: "tertiary",
};

export default badgeVariants;
